/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Done from './Done/index'
import DownloadAction from './DownloadAction/index'
import Failure from './Failure/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Download/DownloadCSV/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'DownloadAction'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'DownloadAction'}>
<DownloadAction
  viewPath={`${viewPath}/DownloadAction`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Done'}>
<Done
  viewPath={`${viewPath}/Done`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Failure'}>
<Failure
  viewPath={`${viewPath}/Failure`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}